import { render, staticRenderFns } from "./ExtractionTemplateOptionList.vue?vue&type=template&id=dc007dd0&scoped=true&"
import script from "./ExtractionTemplateOptionList.vue?vue&type=script&lang=js&"
export * from "./ExtractionTemplateOptionList.vue?vue&type=script&lang=js&"
import style0 from "./ExtractionTemplateOptionList.vue?vue&type=style&index=0&id=dc007dd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc007dd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VRadio,VRow,VSimpleCheckbox,VTextField})
